import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Button } from "@material-ui/core";
import moment from "moment";
import api from "utils/api";
import APIConstant from "utils/constant";
import cogoToast from "cogo-toast";
import { InputTextarea } from "primereact/inputtextarea";
import { CommonConfig } from "CommonConfig";
import { Checkbox } from "primereact/checkbox";

const AddPerformaInvoice = (props) => {
  const [userId, setUserId] = useState("");
  const [invoiceId, setInvoiceId] = useState("");
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [loading, setLoading] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [itemLength, setItemLength] = useState(0);
  const [discountConfig, setDiscountConfig] = useState("percentage");
  const [formData, setFormData] = useState({
    invoiceDate: new Date(),
    invoiceDateErr: false,
    invoiceDateErrText: "",
    orderNo: "",
    orderNoErr: false,
    orderNoErrText: "",
    invoiceNo: "",
    invoiceNoErr: false,
    invoiceNoErrText: "",
    client: "",
    clientErr: false,
    clientErrText: "",
    gstin: "",
    remarks: "",
    totalAmountExcludingGST: 0,
    totalAmountIncludingGST: 0,
    isGst: true,
  });

  const [itemList, setItemList] = useState([
    {
      itemId: "",
      itemName: "",
      hsnCode: "",
      hsnCodeName: "",
      brandId: "",
      brandName: "",
      gst: 0,
      // original base price (excl GST)
      price: 0,
      rateExcludingGST: 0,
      rateIncludingGST: 0,
      quantity: 0,
      unit: "",
      unitName: "",
      totalAmountIncludingGST: 0,
      remarks: "",
      barcode: "",
      mrp: 0,
      amount: 0,
      id: "",
      discount: 0,
    },
  ]);
  const [dropdownData, setDropdownData] = useState({
    client: [],
    product: [],
    hsnCode: [],
    brands: [],
    units: [],
    gstRates: [],
  });

  useEffect(() => {
    let data = localStorage.getItem("Infodata");
    let userPageAccess = localStorage.getItem("PageAccess");
    setUserPageAccess(userPageAccess);
    setUserId(data);

    if (props.location?.state && props.location.state.InvoiceId) {
      GetInvoiceById(data);
      if (props.location.state.Type === "View") {
        setReadOnly(true);
      } else {
        GetProductMaster(data);
        GetClientList(data);
        GetUnitMaster(data);
        GetBrandMaster(data);
        GetHSNCodeMaster(data);
        GetGSTMaster(data);
        GetConfigurationByConfigurationName(data);
      }
    } else {
      GetProductMaster(data);
      GetClientList(data);
      GetUnitMaster(data);
      GetBrandMaster(data);
      GetHSNCodeMaster(data);
      GetGSTMaster(data);
      GenerateUniquePerformaInvoiceNo(data);
      GetConfigurationByConfigurationName(data);
    }
  }, []);

  // ---------- API calls ----------
  const GetProductMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetVariantList, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            product: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetClientList = async (UserId) => {
    let params = {
      UserId: UserId,
      UserType: "Customer",
    };
    api
      .post(APIConstant.path.GetNetworkByUserType, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data;
          setDropdownData((prevState) => ({
            ...prevState,
            client: filterArry,
          }));
        }
      })
      .catch(() => {});
  };

  const GetUnitMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetUnitMaster, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            units: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetBrandMaster = async (UserId) => {
    let params = {
      UserId: UserId,
    };
    api
      .post(APIConstant.path.GetBrandMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            brands: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetHSNCodeMaster = async (UserId) => {
    let params = {
      UserId: UserId,
    };
    api
      .post(APIConstant.path.GetHSNCodeMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");

          setDropdownData((prevState) => ({
            ...prevState,
            hsnCode: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetGSTMaster = async (UserId) => {
    let params = {
      UserId: UserId,
      Type: "GST",
    };
    api
      .post(APIConstant.path.GetMasterListByType, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin").map(
            (data) => ({
              label: data.name,
              value: data.value,
            })
          );

          setDropdownData((prevState) => ({
            ...prevState,
            gstRates: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetConfigurationByConfigurationName = async (UserId) => {
    let params = {
      UserId: UserId,
      ConfigurationName: "Discount",
    };
    api
      .post(APIConstant.path.GetConfigurationByConfigurationName, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          if (response.Data) {
            setDiscountConfig(response.Data.ConfigurationValue);
          }
        }
      });
  };
  const GenerateUniquePerformaInvoiceNo = async (UserId) => {
    let params = {
      UserId: UserId,
    };
    api
      .post(APIConstant.path.GenerateUniquePerformaInvoiceNo, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          setFormData((prevState) => ({
            ...prevState,
            invoiceNo: response.generatedID,
          }));
        }
      });
  };

  const GetInvoiceById = async (UserId) => {
    try {
      let params = {
        UserId,
        InvoiceId: props.location.state.InvoiceId,
      };
      api
        .post(APIConstant.path.GetPerformaInvoiceById, params)
        .then((response) => {
          if (response.Success === 1) {
            const {
              InvoiceDate,
              OrderNo,
              InvoiceNo,
              ClientName,
              GSTIN,
              Remarks,
              TotalAmountExcludingGST,
              TotalAmountIncludingGST,
              ItemList,
              _id,
              IsGst,
              TotalMRP,
              ClientId,
            } = response.Data;
            setFormData((prevState) => ({
              ...prevState,
              invoiceDate: InvoiceDate,
              orderNo: OrderNo,
              invoiceNo: InvoiceNo,
              client: ClientId,
              clientName: ClientName,
              gstin: GSTIN,
              remarks: Remarks,
              totalAmountExcludingGST: TotalAmountExcludingGST || 0,
              totalAmountIncludingGST: TotalAmountIncludingGST || 0,
              isGst: IsGst,
              TotalMRP: TotalMRP,
            }));
            let tempItemList = ItemList.map((item) => ({
              itemId: item.ItemId,
              itemName: item.ItemName,
              hsnCode: item.HSNCode,
              hsnCodeName: item.HSNCodeName,
              brandId: item.Brand,
              brandName: item.BrandName,
              gst: item.GST || 0,
              price: item.RateExcludingGST || 0,
              rateExcludingGST: item.RateExcludingGST || 0,
              rateIncludingGST: item.RateIncludingGST || 0,
              quantity: item.Quantity || 0,
              originalUnit: item.OriginalUnitId,
              unit: item.UnitId,
              unitName: item.UnitName,
              totalAmountIncludingGST: item.TotalAmountIncludingGST || 0,
              remarks: item.Remarks,
              barcode: item.Barcode,
              mrp: item.MRP || 0,
              amount: item.Amount || 0,
              discount: item.Discount || 0,
              id: item?._id,
            }));
            setInvoiceId(_id);
            setItemList(tempItemList);
            setItemLength(ItemList.length);
            updateTotals(tempItemList);
          } else {
            // console.log(response.Message);
          }
        })
        .catch((err) => {});
    } catch (e) {
      console.log(e);
    }
  };

  // ---------- Helpers ----------

  // compute discount amount given a baseInclusive (value in inclusive terms) or baseExclusive depending on context
  // We will use discountConfig consistently:
  // - if discountConfig === "percentage" then discount value stored is percent; when computing absolute discount amount for *inclusive* values we use (value * percent)/100; when computing for exclusive we use (value * percent)/100
  const computeDiscountAmountFromValue = (referenceValue, discountValue) => {
    if (!discountValue) return 0;
    if (discountConfig === "percentage") {
      return (Number(referenceValue || 0) * Number(discountValue || 0)) / 100;
    }
    // 'value'
    return Number(discountValue || 0);
  };

  // Recalculate a single item using current stored values
  const recalcItem = (updated, idx) => {
    const isGst = formData.isGst;
    const gst = Number(updated[idx].gst || 0);
    const origBase = Number(updated[idx].price || 0); // original base price (excl GST)
    const discountVal = Number(updated[idx].discount || 0);

    if (isGst) {
      // Default: apply discount on base (excl GST)
      let discountedBase = origBase;
      if (discountConfig === "percentage") {
        discountedBase = origBase - (origBase * discountVal) / 100;
      } else {
        discountedBase = origBase - discountVal;
      }
      if (discountedBase < 0) discountedBase = 0;

      updated[idx].rateExcludingGST = Number(discountedBase.toFixed(2));
      updated[idx].rateIncludingGST = Number(
        (discountedBase * (1 + gst / 100)).toFixed(2)
      );

      // MRP by default remains original price including GST (unchanged by discount)
      updated[idx].mrp = Number((origBase * (1 + gst / 100)).toFixed(2));

      // amounts
      const qty = Number(updated[idx].quantity || 0);
      updated[idx].amount = Number(
        (Number(updated[idx].rateExcludingGST || 0) * qty).toFixed(2)
      );
      updated[idx].totalAmountIncludingGST = Number(
        (Number(updated[idx].rateIncludingGST || 0) * qty).toFixed(2)
      );
    } else {
      // Non-GST: treat base price as the rate (no GST)
      let base = origBase;
      if (discountConfig === "percentage") {
        base = origBase - (origBase * discountVal) / 100;
      } else {
        base = origBase - discountVal;
      }
      if (base < 0) base = 0;

      updated[idx].rateExcludingGST = Number(base.toFixed(2)); // use same field as rate
      updated[idx].rateIncludingGST = 0; // not used
      // For non-GST we keep rate and mrp same initially (mrp set from original)
      // mrp remains the original variant price (or previously set mrp)
      // amounts
      const qty = Number(updated[idx].quantity || 0);
      updated[idx].amount = Number((base * qty).toFixed(2));
      updated[idx].totalAmountIncludingGST = 0;
    }
  };

  // Update totals for the overall form
  const updateTotals = (updatedItems) => {
    if (!updatedItems || !updatedItems.length) {
      setFormData((prev) => ({
        ...prev,
        totalAmountExcludingGST: 0,
        totalAmountIncludingGST: 0,
      }));
      return;
    }

    const totalExcl = updatedItems.reduce(
      (acc, it) => acc + Number(it.amount || 0),
      0
    );
    const totalIncl = updatedItems.reduce(
      (acc, it) => acc + Number(it.totalAmountIncludingGST || 0),
      0
    );

    setFormData((prev) => ({
      ...prev,
      totalAmountExcludingGST: Number(totalExcl.toFixed(2)),
      totalAmountIncludingGST: Number(totalIncl.toFixed(2)),
    }));
  };

  // ---------- Event handlers ----------

  // Handle form-level changes; also handle isGst toggle to zero/clear irrelevant fields
  const handleFormChange = (value, field, regex) => {
    if (field === "isGst") {
      // toggle GST mode
      const newIsGst = !!value;
      setFormData((prev) => ({
        ...prev,
        isGst: newIsGst,
      }));

      // update items to reflect GST/no-GST fields
      setItemList((prev) => {
        const updated = prev.map((it) => {
          const copy = { ...it };

          if (!newIsGst) {
            // GST → NON-GST  (OPTION A)
            // Use rateIncludingGST as NEW rate
            const finalRate = Number(
              copy.rateIncludingGST || copy.rateExcludingGST || copy.price || 0
            );

            copy.rateExcludingGST = finalRate; // This is NOW the base rate
            copy.rateIncludingGST = 0;
            copy.gst = 0;
            copy.totalAmountIncludingGST = 0;

            // MRP should now match Rate
            copy.mrp = finalRate;

            // Recalculate amount
            const qty = Number(copy.quantity || 0);
            copy.amount = Number((finalRate * qty).toFixed(2));
          } else {
            // NON-GST → GST
            // convert existing rate into rateExcludingGST
            const rateExcl = Number(copy.rateExcludingGST || copy.mrp || 0);
            const gstRate = Number(copy.gst || 0);

            copy.rateExcludingGST = rateExcl;
            copy.rateIncludingGST = Number(
              (rateExcl * (1 + gstRate / 100)).toFixed(2)
            );

            // MRP must become inclusive price
            copy.mrp = copy.rateIncludingGST;

            // Recalculate amounts
            const qty = Number(copy.quantity || 0);
            copy.amount = Number((rateExcl * qty).toFixed(2));
            copy.totalAmountIncludingGST = Number(
              (copy.rateIncludingGST * qty).toFixed(2)
            );
          }

          return copy;
        });

        updateTotals(updated);
        return updated;
      });

      return;
    }

    if (!value && value !== 0) {
      setFormData((prev) => ({
        ...prev,
        [field]: "",
        [`${field}Err`]: true,
        [`${field}ErrText`]: `This field is required`,
      }));
    } else {
      if (!regex || regex.test(value)) {
        setFormData((prev) => ({
          ...prev,
          [field]: value,
          [`${field}Err`]: false,
          [`${field}ErrText`]: "",
        }));
      }
    }
  };

  // When a barcode is entered and Enter pressed, fetch variant by barcode
  const GetVariantByBarcode = async (Barcode, index) => {
    let params = { UserId: userId, Barcode };
    api
      .post(APIConstant.path.GetVariantByBarcode, params)
      .then((response) => {
        if (response.Success === 1) {
          setItemList((prev) => {
            const updated = [...prev];
            let itemData = response.Data;

            updated[index].itemId = itemData.value;
            updated[index].hsnCode = itemData.HSNCode;
            updated[index].gst = itemData.GstRate;
            updated[index].brandId = itemData.Brand;
            updated[index].unit = itemData.UnitId;
            updated[index].originalUnit = itemData.UnitId;
            updated[index].barcode = Barcode;

            if (itemData.Variant) {
              // store original base price in 'price' (excl GST)
              updated[index].price = Number(itemData.Variant.Price || 0);
              const base = Number(itemData.Variant.Price || 0);

              if (formData.isGst) {
                // set rateExcl to base price (discount not applied yet unless discount exists)
                updated[index].rateExcludingGST = Number(base.toFixed(2));
                updated[index].rateIncludingGST = Number(
                  (base * (1 + Number(itemData.GstRate || 0) / 100)).toFixed(2)
                );
                updated[index].mrp = Number(
                  (base * (1 + Number(itemData.GstRate || 0) / 100)).toFixed(2)
                );
                updated[index].gst = Number(itemData.GstRate || 0);

                // apply discount if any
                if (Number(updated[index].discount || 0) > 0) {
                  recalcItem(updated, index);
                } else {
                  const qty = Number(updated[index].quantity || 0);
                  updated[index].amount = Number(
                    (updated[index].rateExcludingGST * qty).toFixed(2)
                  );
                  updated[index].totalAmountIncludingGST = Number(
                    (updated[index].rateIncludingGST * qty).toFixed(2)
                  );
                }
              } else {
                // non-GST: rate and mrp same
                updated[index].gst = 0;
                updated[index].rateExcludingGST = Number(base.toFixed(2));
                updated[index].rateIncludingGST = 0;
                updated[index].totalAmountIncludingGST = 0;
                // MRP same as rate
                updated[index].mrp = Number(base.toFixed(2));

                // apply discount if any
                if (Number(updated[index].discount || 0) > 0) {
                  recalcItem(updated, index);
                } else {
                  const qty = Number(updated[index].quantity || 0);
                  updated[index].amount = Number(
                    (updated[index].rateExcludingGST * qty).toFixed(2)
                  );
                }
              }
            }

            updateTotals(updated);
            return updated;
          });
        } else {
          cogoToast.error(response.Message);
        }
      })
      .catch(() => {});
  };

  const validate = () => {
    let isValid = true;

    let updatedFormData = { ...formData };

    const formFieldsToValidate = [
      { key: "invoiceDate", label: "Date" },
      { key: "invoiceNo", label: "Invoice No" },
      { key: "client", label: "Client" },
    ];

    formFieldsToValidate.forEach(({ key, label }) => {
      if (CommonConfig.isEmpty(updatedFormData[key])) {
        isValid = false;
        updatedFormData[`${key}Err`] = true;
        updatedFormData[`${key}ErrText`] = `${label} is required`;
      } else {
        updatedFormData[`${key}Err`] = false;
        updatedFormData[`${key}ErrText`] = "";
      }
    });

    setFormData(updatedFormData);

    let tempItems = [...itemList];

    tempItems = tempItems.map((item) => {
      const updatedItem = { ...item };

      const itemFields = [
        { key: "itemId", label: "Item" },
        { key: "unit", label: "Unit" },
      ];

      itemFields.forEach(({ key, label }) => {
        if (CommonConfig.isEmpty(item[key])) {
          isValid = false;
          updatedItem[`${key}Err`] = true;
          updatedItem[`${key}ErrText`] = `${label} is required`;
        } else {
          updatedItem[`${key}Err`] = false;
          updatedItem[`${key}ErrText`] = "";
        }
      });

      return updatedItem;
    });

    setItemList(tempItems);

    if (!itemList.length) {
      isValid = false;
      cogoToast.error("Please select items");
    }

    return isValid;
  };

  const AddInvoice = async () => {
    setLoading(true);

    if (!validate()) return setLoading(false);

    try {
      const payload = {
        InvoiceDate: formData.invoiceDate,
        InvoiceNo: formData.invoiceNo,
        Client: formData.client,
        ClientName: dropdownData.client.find(
          (item) => item.value === formData.client
        )?.label,
        GSTIN: formData.gstin,
        Remarks: formData.remarks,
        TotalAmountExcludingGST: formData.totalAmountExcludingGST,
        TotalAmountIncludingGST: formData.totalAmountIncludingGST,
        ItemList: itemList.map((item) => {
          return {
            ItemId: item.itemId,
            ItemName: dropdownData.product.find(
              (obj) => obj.value === item.itemId
            )?.label,
            HSNCode: item.hsnCode,
            HSNCodeName: dropdownData.hsnCode.find(
              (obj) => obj.value === item.hsnCode
            )?.label,
            Brand: item.brandId,
            BrandName: dropdownData.brands.find(
              (obj) => obj.value === item.brandId
            )?.label,
            RateExcludingGST: item.rateExcludingGST,
            GST: item.gst,
            GSTName: dropdownData.gstRates.find((obj) => obj.value === item.gst)
              ?.label,
            RateIncludingGST: item.rateIncludingGST,
            Quantity: item.quantity,
            Discount: item.discount,
            UnitId: item.unit,
            UnitName: dropdownData.units.find((obj) => obj.value === item.unit)
              ?.label,
            OriginalUnitId: item.originalUnit,
            TotalAmountIncludingGST: item.totalAmountIncludingGST,
            Remarks: item.remarks,
            Barcode: item.barcode,
            MRP: item.mrp,
            Amount: item.amount,
            id: item.id,
          };
        }),
        UserId: userId,
        InvoiceId: invoiceId,
        IsGst: formData?.isGst,
        TotalMRP: itemList?.length
          ? itemList?.reduce((a, b) => Number(a) + Number(b.mrp), 0)
          : 0.0,
        TotalAmount: itemList?.length
          ? itemList?.reduce((a, b) => Number(a) + Number(b.amount), 0)
          : 0.0,
      };

      api
        .post(APIConstant.path.AddUpdatePerformaInvoice, payload)
        .then((res) => {
          if (res.Success == 1) {
            setLoading(false);
            cogoToast.success(res.Message);
            props.history.push("/admin/performa-invoice");
          } else {
            setLoading(false);
            cogoToast.error(res.Message);
          }
        });
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === "Enter") {
      try {
        if (itemList[idx].barcode) {
          GetVariantByBarcode(itemList[idx].barcode, idx);
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  // main item list change handler
  const handleItemListChange = (value, field, index, regex) => {
    // No value (empty) handling
    if (!value && value !== 0) {
      setItemList((prev) => {
        const updated = [...prev];
        updated[index][field] = value;
        updated[index][`${field}Err`] = true;
        updated[index][`${field}ErrText`] = `This field is required`;
        // if clearing discount, set 0 and recalc
        if (field === "discount") {
          updated[index].discount = 0;
          recalcItem(updated, index);
        }
        updateTotals(updated);
        return updated;
      });
      return;
    }

    // value provided
    if (!regex || regex.test(value) || value === 0) {
      setItemList((prev) => {
        const updated = [...prev];
        // ensure numeric conversions where appropriate
        if (
          [
            "quantity",
            "discount",
            "gst",
            "rateExcludingGST",
            "rateIncludingGST",
            "mrp",
          ].includes(field)
        ) {
          // allow numeric strings
          // But keep raw value assignment so controlled inputs show what user typed
        }

        if (field === "barcode") {
          value = value.toUpperCase();
        }

        updated[index][field] = value;
        updated[index][`${field}Err`] = false;
        updated[index][`${field}ErrText`] = "";

        // Field-specific logic
        if (field === "itemId") {
          // product selected
          let itemData = dropdownData.product.find(
            (item) => item.value === value
          );
          if (itemData) {
            updated[index].hsnCode = itemData.HSNCode;
            updated[index].gst = Number(itemData.GstRate || 0);
            updated[index].brandId = itemData.Brand;
            updated[index].unit = itemData.UnitId;
            updated[index].originalUnit = itemData.UnitId;

            if (itemData.Variant) {
              updated[index].price = Number(itemData.Variant.Price || 0);
              const base = Number(itemData.Variant.Price || 0);

              if (formData.isGst) {
                // set base rates and mrp
                updated[index].rateExcludingGST = Number(base.toFixed(2));
                updated[index].rateIncludingGST = Number(
                  (base * (1 + Number(itemData.GstRate || 0) / 100)).toFixed(2)
                );
                // MRP similar to rate including gst
                updated[index].mrp = Number(
                  (base * (1 + Number(itemData.GstRate || 0) / 100)).toFixed(2)
                );

                // apply discount if present, else amounts directly from rates
                if (Number(updated[index].discount || 0) > 0) {
                  recalcItem(updated, index);
                } else {
                  const qty = Number(updated[index].quantity || 0);
                  updated[index].amount = Number(
                    (updated[index].rateExcludingGST * qty).toFixed(2)
                  );
                  updated[index].totalAmountIncludingGST = Number(
                    (updated[index].rateIncludingGST * qty).toFixed(2)
                  );
                }
              } else {
                // non-GST => rate and mrp same
                updated[index].gst = 0;
                updated[index].rateExcludingGST = Number(base.toFixed(2));
                updated[index].rateIncludingGST = 0;
                updated[index].totalAmountIncludingGST = 0;
                updated[index].mrp = Number(base.toFixed(2));
                if (Number(updated[index].discount || 0) > 0) {
                  recalcItem(updated, index);
                } else {
                  const qty = Number(updated[index].quantity || 0);
                  updated[index].amount = Number(
                    (updated[index].rateExcludingGST * qty).toFixed(2)
                  );
                }
              }
            }
          }
        } else if (field === "quantity") {
          // recompute amounts using current rates
          updated[index].quantity = Number(value || 0);
          const qty = Number(updated[index].quantity || 0);
          updated[index].amount = Number(
            (Number(updated[index].rateExcludingGST || 0) * qty).toFixed(2)
          );
          if (formData.isGst) {
            updated[index].totalAmountIncludingGST = Number(
              (Number(updated[index].rateIncludingGST || 0) * qty).toFixed(2)
            );
          } else {
            updated[index].totalAmountIncludingGST = 0;
          }
        } else if (field === "discount") {
          // set discount and recalc
          updated[index].discount = Number(value || 0);
          // recalc based on original price
          recalcItem(updated, index);
        } else if (field === "gst") {
          // update gst rate
          updated[index].gst = Number(value || 0);

          const gstRate = Number(updated[index].gst || 0);
          const rateExcl = Number(updated[index].rateExcludingGST || 0);

          // Recalculate rateIncl
          updated[index].rateIncludingGST = Number(
            (rateExcl * (1 + gstRate / 100)).toFixed(2)
          );

          const qty = Number(updated[index].quantity || 0);

          // Recalculate amounts
          updated[index].amount = Number((rateExcl * qty).toFixed(2));
          updated[index].totalAmountIncludingGST = Number(
            (updated[index].rateIncludingGST * qty).toFixed(2)
          );

          // ----- NEW LOGIC FOR MRP -----
          const discountVal = Number(updated[index].discount || 0);

          if (discountVal > 0) {
            // Discount exists → MRP must not auto-update
            // because rate is already = (MRP - discount)
            // Do nothing to MRP
          } else {
            // No discount → MRP must follow inclusive rate
            updated[index].mrp = updated[index].rateIncludingGST;
          }
        } else if (field === "rateExcludingGST") {
          // user manually edited base rate (excl GST)
          const manualBase = Number(value || 0);
          updated[index].price = manualBase; // consider this the base for further calculations
          // reset discount? we keep discount as-is but adjust MRP according to rule:
          // If discount exists -> MRP = rateIncludingGST + discountAmount (discountAmount derived on inclusive/ chosen method)
          const gstRate = Number(updated[index].gst || 0);
          updated[index].rateExcludingGST = Number(manualBase.toFixed(2));
          updated[index].rateIncludingGST = Number(
            (manualBase * (1 + gstRate / 100)).toFixed(2)
          );
          const qty = Number(updated[index].quantity || 0);
          updated[index].amount = Number(
            (updated[index].rateExcludingGST * qty).toFixed(2)
          );
          updated[index].totalAmountIncludingGST = Number(
            (updated[index].rateIncludingGST * qty).toFixed(2)
          );

          // compute discount amount relative to inclusive value if percent config
          const discountVal = Number(updated[index].discount || 0);
          if (discountVal > 0) {
            // get discount absolute amount using inclusive reference
            const discountAbs = computeDiscountAmountFromValue(
              updated[index].rateIncludingGST,
              discountVal
            );
            updated[index].mrp = Number(
              (updated[index].rateIncludingGST + discountAbs).toFixed(2)
            );
          } else {
            updated[index].mrp = Number(
              updated[index].rateIncludingGST.toFixed(2)
            );
          }
        } else if (field === "rateIncludingGST") {
          // user edited inclusive rate
          const manualIncl = Number(value || 0);
          const gstRate = Number(updated[index].gst || 0);
          // derive base
          const derivedBase = gstRate
            ? manualIncl / (1 + gstRate / 100)
            : manualIncl;
          updated[index].price = Number(derivedBase.toFixed(2));
          updated[index].rateExcludingGST = Number(derivedBase.toFixed(2));
          updated[index].rateIncludingGST = Number(manualIncl.toFixed(2));
          const qty = Number(updated[index].quantity || 0);
          updated[index].amount = Number(
            (updated[index].rateExcludingGST * qty).toFixed(2)
          );
          updated[index].totalAmountIncludingGST = Number(
            (updated[index].rateIncludingGST * qty).toFixed(2)
          );

          // MRP update per rule: when Rate is manually edited then if there is discount then MRP becomes rate + discount else Mrp = rate.
          const discountVal = Number(updated[index].discount || 0);
          if (discountVal > 0) {
            const discountAbs = computeDiscountAmountFromValue(
              manualIncl,
              discountVal
            );
            updated[index].mrp = Number((manualIncl + discountAbs).toFixed(2));
          } else {
            updated[index].mrp = Number(manualIncl.toFixed(2));
          }
        } else if (field === "mrp") {
          // user edited MRP
          const newMrp = Number(value || 0);
          updated[index].mrp = Number(newMrp.toFixed(2));
          const discountVal = Number(updated[index].discount || 0);
          if (formData.isGst) {
            // We interpret MRP as inclusive rate.
            // discountAbs computed wrt inclusive value
            let discountAbs = 0;
            if (discountVal > 0) {
              discountAbs = computeDiscountAmountFromValue(newMrp, discountVal);
            }
            // per your rule: if discount >0 then rate = mrp - discount else rate = mrp
            const rateIncl = Number((newMrp - discountAbs).toFixed(2));
            const gstRate = Number(updated[index].gst || 0);
            const rateExcl = gstRate
              ? Number((rateIncl / (1 + gstRate / 100)).toFixed(2))
              : rateIncl;
            updated[index].rateIncludingGST = rateIncl;
            updated[index].rateExcludingGST = rateExcl;
            updated[index].price = Number(rateExcl.toFixed(2)); // update base price to derived
            const qty = Number(updated[index].quantity || 0);
            updated[index].amount = Number((rateExcl * qty).toFixed(2));
            updated[index].totalAmountIncludingGST = Number(
              (rateIncl * qty).toFixed(2)
            );
          } else {
            // non-GST: rate and mrp same after applying discount rule
            let discountAbs = 0;
            if (discountVal > 0) {
              discountAbs = computeDiscountAmountFromValue(newMrp, discountVal);
            }
            const rate = Number((newMrp - discountAbs).toFixed(2));
            updated[index].rateExcludingGST = rate;
            updated[index].price = rate;
            updated[index].rateIncludingGST = 0;
            updated[index].totalAmountIncludingGST = 0;
            const qty = Number(updated[index].quantity || 0);
            updated[index].amount = Number((rate * qty).toFixed(2));
          }
        } else if (field === "mrp_manual") {
          // Not used - placeholder
        } else {
          // generic fields handled
        }

        updateTotals(updated);
        return updated;
      });
    }
  };

  const addItem = () => {
    setItemLength((prev) => prev + 1);
    setItemList((prev) => [
      ...prev,
      {
        itemId: "",
        itemName: "",
        hsnCode: "",
        hsnCodeName: "",
        brandId: "",
        brandName: "",
        gst: formData.isGst ? 0 : 0,
        price: 0,
        rateExcludingGST: 0,
        rateIncludingGST: 0,
        quantity: 0,
        unit: "",
        unitName: "",
        totalAmountIncludingGST: 0,
        remarks: "",
        barcode: "",
        mrp: 0,
        amount: 0,
        id: "",
        discount: 0,
      },
    ]);
  };

  const removeItem = (index) => {
    setItemList((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      updateTotals(updated);
      return updated;
    });
  };

  // ---------- Render ----------
  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard e-inward-body">
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div
          className="ship-heading-area p-d-flex p-ai-center"
          onClick={() => {
            props.history.push("/admin/performa-invoice");
          }}
        >
          <i className="pi pi-arrow-right rotate" />
          <h2>Performa Invoice</h2>
        </div>
      </div>
      <hr />
      <div className="container-body e-container-body">
        <div className="conatiner-tab-body p-mt-3 p-mx-1 e-view-card">
          <div className="p-grid">
            <div className="p-sm-12 p-md-3 p-mt-1">
              <div className="p-d-flex p-ai-center p-mt-4">
                <div className="flex align-items-center">
                  <Checkbox
                    inputId="apply"
                    name="isGst"
                    onChange={(e) => handleFormChange(e.checked, "isGst")}
                    checked={formData.isGst}
                  />
                  <label htmlFor="apply" className="p-ml-2">
                    GST
                  </label>
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Invoice Date</p>
                  {readOnly ? (
                    <p className="sub-text">
                      {formData.invoiceDate
                        ? moment(formData.invoiceDate).format("DD/MM/YYYY")
                        : ""}
                    </p>
                  ) : (
                    <>
                      <div>
                        <Calendar
                          value={
                            formData.invoiceDate
                              ? new Date(formData.invoiceDate)
                              : null
                          }
                          onChange={(e) =>
                            handleFormChange(e.value, "invoiceDate")
                          }
                          dateFormat="dd/mm/yy"
                          showIcon={false}
                          placeholder="Select Date"
                          className="p-w-100"
                          autoFocus
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.invoiceDateErr
                          ? formData.invoiceDateErrText
                          : null}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Invoice No</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.invoiceNo}</p>
                  ) : (
                    <>
                      <div>
                        <InputText
                          value={formData.invoiceNo}
                          onChange={(e) =>
                            handleFormChange(e.target.value, "invoiceNo")
                          }
                          maxLength={30}
                          placeholder="Invoice No"
                          className="p-w-100 e-input-common"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.invoiceNoErr
                          ? formData.invoiceNoErrText
                          : null}{" "}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Client Name</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.clientName}</p>
                  ) : (
                    <>
                      <div>
                        <Dropdown
                          filter
                          options={dropdownData.client}
                          value={formData.client}
                          onChange={(e) => handleFormChange(e.value, "client")}
                          placeholder="Client"
                          className="p-w-100"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.clientErr ? formData.clientErrText : null}{" "}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            {formData.isGst ? (
              <div className="p-sm-12 p-md-3">
                <div className="p-w-100 ">
                  <div className="custom-inputs e-order-mng order">
                    <p className="text p-mb-1">GSTIN</p>
                    {readOnly ? (
                      <p className="sub-text">{formData.gstin}</p>
                    ) : (
                      <>
                        <div>
                          <InputText
                            value={formData.gstin}
                            onChange={(e) =>
                              handleFormChange(
                                e.target.value,
                                "gstin",
                                /^[A-Za-z0-9]+$/i
                              )
                            }
                            maxLength={25}
                            placeholder="GST"
                            className="p-w-100 e-input-common"
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ) : null}
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">
                    {formData.isGst ? "Total Amt (Excl. GST)" : "Total Amt"}
                  </p>
                  {readOnly ? (
                    <p className="sub-text">
                      {formData.isGst
                        ? formData.totalAmountExcludingGST
                        : formData.totalAmountExcludingGST}
                    </p>
                  ) : (
                    <>
                      <div>
                        <InputText
                          disabled
                          value={
                            formData.isGst
                              ? formData.totalAmountExcludingGST
                              : formData.totalAmountExcludingGST
                          }
                          onChange={(e) =>
                            handleFormChange(
                              e.target.value,
                              "totalAmountExcludingGST",
                              /^\d+(\.\d{0,2})?$/i
                            )
                          }
                          maxLength={10}
                          placeholder="Amount excluding GST"
                          className="p-w-100 e-input-common"
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            {formData.isGst ? (
              <div className="p-sm-12 p-md-3">
                <div className="p-w-100 ">
                  <div className="custom-inputs e-order-mng order">
                    <p className="text p-mb-1">Total Amt (Incl. GST)</p>
                    {readOnly ? (
                      <p className="sub-text">
                        {formData.totalAmountIncludingGST}
                      </p>
                    ) : (
                      <>
                        <div>
                          <InputText
                            disabled
                            value={formData.totalAmountIncludingGST}
                            onChange={(e) =>
                              handleFormChange(
                                e.target.value,
                                "totalAmountIncludingGST",
                                /^\d+(\.\d{0,2})?$/i
                              )
                            }
                            maxLength={10}
                            placeholder="Amount including GST"
                            className="p-w-100 e-input-common"
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ) : null}

            <div className="p-sm-12">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Remarks</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.remarks}</p>
                  ) : (
                    <InputTextarea
                      className="p-w-100"
                      value={formData.remarks}
                      onChange={(e) =>
                        handleFormChange(e.target.value, "remarks")
                      }
                      maxLength={200}
                      placeholder="Remarks"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          {itemList?.map((item, vIdx) => (
            <div
              key={vIdx}
              className="item-section p-mb-3"
              style={{
                background: "#fff",
                borderRadius: "8px",
                border: "2px dotted #bdbdbd",
                width: "100%",
                marginBottom: "12px",
                position: "relative",
                boxSizing: "border-box",
                transition: "border 0.2s",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  background: "#f5f5f5",
                  borderRadius: "8px",
                  padding: "12px 20px",
                  marginBottom: "18px",
                  minHeight: "48px",
                }}
              >
                <span
                  style={{
                    fontWeight: "600",
                    color: "#09090B",
                    fontSize: "1rem",
                    letterSpacing: "0.5px",
                  }}
                >
                  Item {vIdx + 1}
                </span>
                {!readOnly && (
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => removeItem(vIdx)}
                    style={{
                      minWidth: 120,
                      borderRadius: 8,
                      fontWeight: 500,
                      boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                      background: "#fff",
                    }}
                  >
                    <i className="pi pi-trash" style={{ marginRight: 8 }}></i>{" "}
                    Delete Item
                  </Button>
                )}
              </div>
              <div className="p-grid p-px-4">
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Barcode</p>
                      {readOnly ? (
                        <p className="sub-text">{item.barcode}</p>
                      ) : (
                        <InputText
                          value={item.barcode}
                          onChange={(e) =>
                            handleItemListChange(
                              e.target.value,
                              "barcode",
                              vIdx
                            )
                          }
                          maxLength={50}
                          onKeyDown={(e) => handleKeyDown(e, vIdx)}
                          placeholder="Barcode"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Raw Material/Item</p>
                      {readOnly ? (
                        <p className="sub-text">{item.itemName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={dropdownData.product}
                              value={item.itemId}
                              onChange={(e) =>
                                handleItemListChange(e.value, "itemId", vIdx)
                              }
                              placeholder="Item"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.itemErr ? item.itemErrText : null}{" "}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">HSN Code</p>
                      {readOnly ? (
                        <p className="sub-text">{item.hsnCodeName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={dropdownData.hsnCode}
                              value={item.hsnCode}
                              onChange={(e) =>
                                handleItemListChange(e.value, "hsnCode", vIdx)
                              }
                              placeholder="HSN Code"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.hsnCodeErr ? item.hsnCodeErrText : null}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Brand Name</p>
                      {readOnly ? (
                        <p className="sub-text">{item.brandName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={dropdownData.brands}
                              value={item.brandId}
                              onChange={(e) =>
                                handleItemListChange(e.value, "brandId", vIdx)
                              }
                              placeholder="Brand Name"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.brandErr ? item.brandErrText : null}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Quantity</p>
                      {readOnly ? (
                        <p className="sub-text">{item.quantity}</p>
                      ) : (
                        <>
                          <div>
                            <InputText
                              value={item.quantity}
                              onChange={(e) =>
                                handleItemListChange(
                                  e.target.value,
                                  "quantity",
                                  vIdx,
                                  /^\d+(\.\d{0,2})?$/i
                                )
                              }
                              maxLength={10}
                              placeholder="Quantity"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.quantityErr ? item.quantityErrText : null}{" "}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Unit</p>
                      {readOnly ? (
                        <p className="sub-text">{item.unitName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={dropdownData.units}
                              value={item.unit}
                              onChange={(e) =>
                                handleItemListChange(e.value, "unit", vIdx)
                              }
                              placeholder="Unit"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.unitErr ? item.unitErrText : null}{" "}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Rate (Excl GST or Rate for non-GST) */}
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">
                        {formData.isGst ? "Rate (Excl. of GST)" : "Rate"}
                      </p>
                      {readOnly ? (
                        <p className="sub-text">{item.rateExcludingGST}</p>
                      ) : (
                        <>
                          <div>
                            <InputText
                              value={item.rateExcludingGST}
                              onChange={(e) =>
                                handleItemListChange(
                                  e.target.value,
                                  "rateExcludingGST",
                                  vIdx,
                                  /^\d+(\.\d{0,2})?$/i
                                )
                              }
                              maxLength={15}
                              placeholder="Rate"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* GST % (visible only when isGst) */}
                {formData.isGst ? (
                  <>
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">GST %</p>
                          {readOnly ? (
                            <p className="sub-text">{item.gst}</p>
                          ) : (
                            <>
                              <div>
                                <Dropdown
                                  filter
                                  options={dropdownData.gstRates}
                                  value={item.gst}
                                  onChange={(e) =>
                                    handleItemListChange(e.value, "gst", vIdx)
                                  }
                                  placeholder="GST"
                                  className="p-w-100 e-input-common"
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">Rate (Incl. of GST)</p>
                          {readOnly ? (
                            <p className="sub-text">{item.rateIncludingGST}</p>
                          ) : (
                            <>
                              <div>
                                <InputText
                                  value={item.rateIncludingGST}
                                  onChange={(e) =>
                                    handleItemListChange(
                                      e.target.value,
                                      "rateIncludingGST",
                                      vIdx,
                                      /^\d+(\.\d{0,2})?$/i
                                    )
                                  }
                                  maxLength={15}
                                  placeholder="Rate"
                                  className="p-w-100 e-input-common"
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}

                {/* Total Amount (Incl. GST) - disabled when isGst true */}
                {formData.isGst ? (
                  <div className="p-sm-12 p-md-3">
                    <div className="p-w-100 ">
                      <div className="custom-inputs e-order-mng order">
                        <p className="text p-mb-1">Total Amount (Incl. GST)</p>
                        {readOnly ? (
                          <p className="sub-text">
                            {item.totalAmountIncludingGST}
                          </p>
                        ) : (
                          <>
                            <div>
                              <InputText
                                disabled
                                value={item.totalAmountIncludingGST}
                                onChange={(e) =>
                                  handleItemListChange(
                                    e.target.value,
                                    "totalAmountIncludingGST",
                                    vIdx,
                                    /^\d+(\.\d{0,2})?$/i
                                  )
                                }
                                maxLength={15}
                                placeholder="Amount"
                                className="p-w-100 e-input-common"
                              />
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                ) : null}

                {/* Discount */}
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Discount</p>
                      {readOnly ? (
                        <p className="sub-text">{item.discount}</p>
                      ) : (
                        <>
                          <div>
                            <InputText
                              value={item.discount}
                              onChange={(e) =>
                                handleItemListChange(
                                  e.target.value,
                                  "discount",
                                  vIdx,
                                  /^\d+(\.\d{0,2})?$/i
                                )
                              }
                              maxLength={15}
                              placeholder="discount"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* MRP */}
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">MRP</p>
                      {readOnly ? (
                        <p className="sub-text">{item.mrp}</p>
                      ) : (
                        <InputText
                          value={item.mrp}
                          onChange={(e) =>
                            handleItemListChange(
                              e.target.value,
                              "mrp",
                              vIdx,
                              /^\d+(\.\d{0,2})?$/i
                            )
                          }
                          maxLength={10}
                          placeholder="MRP"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>

                {/* Total Amount (Excl. GST) - disabled */}
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">
                        {formData.isGst
                          ? "Total Amount (Excl. GST)"
                          : "Total Amt"}
                      </p>
                      {readOnly ? (
                        <p className="sub-text">{item.amount}</p>
                      ) : (
                        <InputText
                          disabled
                          value={
                            Number(item?.rateExcludingGST || 0) *
                            Number(item?.quantity || 0)
                          }
                          onChange={(e) =>
                            handleItemListChange(e.target.value, "amount", vIdx)
                          }
                          maxLength={10}
                          placeholder="Amount"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className="p-sm-12">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Remarks</p>
                      {readOnly ? (
                        <p className="sub-text">{item.remarks}</p>
                      ) : (
                        <InputTextarea
                          className="p-w-100"
                          value={item.remarks}
                          onChange={(e) =>
                            handleItemListChange(
                              e.target.value,
                              "remarks",
                              vIdx
                            )
                          }
                          maxLength={200}
                          placeholder="Remarks"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
          {!readOnly && (
            <Button
              variant="outlined"
              color="primary"
              onClick={addItem}
              className="add-item-btn"
            >
              <i className="pi pi-plus" style={{ marginRight: 8 }}></i> Add Item
            </Button>
          )}
        </div>
      </div>
      <div className="p-d-flex p-ai-center p-jc-start e-inward-footer">
        <button
          className="secondary-btn"
          onClick={() => {
            props.history.push("/admin/performa-invoice");
          }}
        >
          Cancel
        </button>

        {readOnly ? null : (
          <Button
            className="primary-btn color-white p-ml-1"
            onClick={() => AddInvoice()}
            disabled={loading}
          >
            {loading ? "Submitting" : "Submit"}
          </Button>
        )}
      </div>
    </div>
  );
};

export default AddPerformaInvoice;
